module.exports = __webpack_public_path__ + "static/media/preloader-SMALL-PennyMac-Earthquake.91ae961a.gif";